module.exports = __webpack_public_path__ + "static/media/5cirqueduceleste3.0d40325d.jpg";